module.exports = __webpack_public_path__ + "img/ic_disconect_all.460ebe4c.svg";